'use client'

import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren } from 'react'
import queryClient from './queryClient'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { DehydratedState } from '@tanstack/react-query'

type QueryProviderProps = PropsWithChildren & { dehydratedState?: DehydratedState | null }

const QueryProvider = ({ children, dehydratedState }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default QueryProvider
